import React, { useState, useEffect } from "react";

import { TextRow, TextGrid, AutoResult, ResultRow } from "./SubTextStyled";
import currencies from "../../helpers/getCurrency";
export default ({
  bet,
  bombs,
  leftSpheres,
  stateRound,
  handleAbove,
  isAutoOn,
  manualPlay,
  result,
  floorFigure,
  handleAboveAnim,
  autoAnim,
  audio,
  newDisable,
  userInfo,
}) => {
  const { nextCoef, currentCoef, winAmount } = stateRound;
  const { curr, precision } = userInfo;
  const [win, setWin] = useState(false);
  const [value, setValue] = useState(winAmount);
  const [autoAnimate, setAutoAnimate] = useState(false);

  const [btnAnimation, setBtnAnimation] = useState("false");

  useEffect(() => {
    setValue(winAmount);
  }, [winAmount]);

  useEffect(() => {
    setAutoAnimate(autoAnim);
  }, [autoAnim]);

  useEffect(() => {
    if (winAmount > 0) {
      setWin(true);
    } else {
      setWin(false);
    }
  }, [winAmount]);

  const results = {
    winCoef: currentCoef,
    bet: bet,
    currency: currencies[curr],
  };
  const roundInfo = {
    yellow: leftSpheres,
    red: bombs,
    profit: currentCoef && floorFigure(currentCoef, 2) + "x",
    next: nextCoef && floorFigure(nextCoef, 2) + "x",
  };

  return (
    <>
      {manualPlay ? (
        <div style={{ position: "relative" }}>
          <TextRow fadeOut={manualPlay}>
            <p>Number of mines {bombs}</p>
          </TextRow>
          <TextGrid textApear={manualPlay}>
            {Object.entries(roundInfo).map(([key, value]) => {
              return (
                <div key={key}>
                  <p>{key}</p>
                  <span>{value}</span>
                </div>
              );
            })}
          </TextGrid>
        </div>
      ) : isAutoOn ? (
        <AutoResult win={win} autoAnimate={autoAnimate}>
          <div>
            <p>win</p>
          </div>
          <div>
            <span>
              {floorFigure(value, precision)} {currencies[curr]}
            </span>
          </div>
        </AutoResult>
      ) : (
        <TextRow
          win={win}
          btnClick={btnAnimation}
          textApear={!result}
          newDisable={newDisable}
        >
          {result ? (
            <>
              <ResultRow textApear={result} win={win}>
                {floorFigure(results.winCoef, 2)}X | {""}
                {floorFigure(results.bet, precision)} {results.currency}
              </ResultRow>
              <TextGrid fadeOut={result}>
                {Object.entries(roundInfo).map(([key, value]) => {
                  return (
                    <div key={key}>
                      <p>{key}</p>
                      <span>{value}</span>
                    </div>
                  );
                })}
              </TextGrid>
            </>
          ) : (
            <p
              onAnimationEnd={() => setBtnAnimation("")}
              onClick={() => {
                setBtnAnimation("mines");
                audio();
                setTimeout(() => {
                  handleAboveAnim(true);
                  handleAbove("selectMines");
                }, 100);
              }}
            >
              Number of mines {bombs}
            </p>
          )}
        </TextRow>
      )}
    </>
  );
};
